import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";

import { Adg4Button } from "@/components/adg4/button/src";
import { Adg4TextUnderline } from "@/components/adg4/text-underline/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

export const HeroConfluenceCTA = () => {
    return (
        <UFOSegment name="paid-lp-xflow-redesign-experiment-main-hero">
            <section
                id="HomePageBpsRedesignTemplate.heroConfluenceCTA"
                css={confluenceHeroStyles}
            >
                <Row>
                    <div>
                        <h2
                            className="superhero-contrast"
                            css={heroTitleStyles}
                        >
                            <FormattedMessage
                                id="HomePageBpsRedesignTemplate.confluenceHero.mainHero"
                                defaultMessage="Using Jira?{br}It works even <better>better</better> with Confluence"
                                values={{
                                    better: (str: ReactNode) => (
                                        <Adg4TextUnderline
                                            underline={
                                                <svg
                                                    width="100%"
                                                    height="30"
                                                    viewBox="0 0 306 42"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z"
                                                        fill="#FFA900"
                                                    />
                                                </svg>
                                            }
                                        >
                                            {str}
                                        </Adg4TextUnderline>
                                    ),
                                    br: <br />
                                }}
                            />
                        </h2>
                        <Adg4Button
                            variant="primary"
                            color="blue"
                            href={useLocalizedHref(
                                "/try/cloud/signup?bundle=confluence"
                            )}
                            dataEventProps={{
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "heroSection",
                                "data-product-key":
                                    "confluence-PaidLpXflowRedesignExperiment",
                                "data-label-english": "Try it now"
                            }}
                            css={heroGetStartedStyles}
                            target="_blank"
                        >
                            {
                                <FormattedMessage
                                    id="HomePageBpsRedesignTemplate.confluenceHero.tryItNowCtaButton"
                                    defaultMessage="Try it now"
                                />
                            }
                        </Adg4Button>
                    </div>
                </Row>
            </section>
        </UFOSegment>
    );
};

const confluenceHeroStyles = css({
    textAlign: "center",
    overflow: "hidden",
    marginBlockEnd: "40px",
    marginBlockStart: "145px",
    [media.below.md]: {
        marginBlockStart: "130px"
    }
});

const heroTitleStyles = css({
    marginBlock: "19px",

    [media.below.sm]: {
        fontSize: "40px"
    }
});

const heroGetStartedStyles = css({
    marginBlock: "30px 40px",

    [media.below.sm]: {
        marginBlock: "20px 45px"
    }
});
